(() => {
  'use strict';
  if(window.EdenHomeRoomCarousel){window.EdenHomeRoomCarousel.mount(document);return;}
  const delay=6000;
  function init(root){
    if(root.edenHomeRoomCarousel)return;
    const track=root.querySelector('.eg-rooms__list'),dots=root.querySelector('.eg-rooms__dots'),scope=root.closest('section'),tabs=scope?.querySelector('.eg-tabs');
    if(!track||!dots)return;
    const abort=new AbortController(),on=(el,event,fn,options={})=>el?.addEventListener(event,fn,{...options,signal:abort.signal});
    const reduced=matchMedia('(prefers-reduced-motion: reduce)'),hover=matchMedia('(hover: hover) and (pointer: fine)');
    let positions=[],items=[],index=0,timer=0,frame=0,resetFrame=0,refreshFrame=0,pendingIndex=0,inView=false,gesture=null,ignoreClickUntil=0;
    track.id ||= root.id+'-track';
    root.classList.add('is-carousel-ready');root.setAttribute('role','region');root.setAttribute('aria-roledescription','carusel');root.setAttribute('aria-label',window.EdenI18n.t("text_b3a864159c37"));
    dots.removeAttribute('aria-hidden');dots.setAttribute('role','group');dots.setAttribute('aria-label',window.EdenI18n.t("text_873e74ad0fd2"));
    const visibleCards=()=>[...track.children].filter(c=>c.classList.contains('eg-card')&&!c.hidden);
    function closest(){
      let best=0,distance=Infinity;
      const scrollLeft=track.scrollLeft;
      positions.forEach((left,i)=>{const d=Math.abs(scrollLeft-left);if(d<distance){distance=d;best=i;}});
      return best;
    }
    function mark(next){
      index=next;root.dataset.carouselIndex=String(index);
      [...dots.children].forEach((button,i)=>{button.toggleAttribute('data-active',i===index);if(i===index)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');button.tabIndex=i===index?0:-1;});
    }
    function go(next,animate=true){
      if(!positions.length)return;
      next=Math.max(0,Math.min(positions.length-1,next));
      if(animate&&!reduced.matches)track.scrollTo({left:positions[next],behavior:'smooth'});
      else track.scrollTo({left:positions[next],behavior:'instant'});
      mark(next);
    }
    function stop(){clearTimeout(timer);timer=0;}
    function canPlay(){const focused=document.activeElement;return inView&&!document.hidden&&!reduced.matches&&!gesture&&positions.length>1&&!(scope.contains(focused)&&focused?.matches(':focus-visible'))&&!(hover.matches&&root.matches(':hover'))&&!document.querySelector('dialog[open]');}
    function schedule(){
      stop();if(!canPlay())return;
      timer=setTimeout(()=>{if(!canPlay()){schedule();return;}const next=(closest()+1)%positions.length;go(next,next!==0);schedule();},delay);
    }
    function refresh(next=index){
      stop();cancelAnimationFrame(resetFrame);cancelAnimationFrame(refreshFrame);
      pendingIndex=next;track.classList.add('is-resetting');
      // Let the new tab/readiness styles reach layout before measuring. Rapid
      // changes share one refresh; scroll snapping is restored as before.
      refreshFrame=requestAnimationFrame(()=>{refreshFrame=requestAnimationFrame(()=>{
        refreshFrame=0;refreshLayout(pendingIndex);
      });});
    }
    function refreshLayout(next){
      items=visibleCards();positions=[];
      const max=Math.max(0,track.scrollWidth-track.clientWidth);
      const trackLeft=track.offsetLeft;
      items=items.filter(card=>{const position=Math.min(max,Math.max(0,card.offsetLeft-trackLeft));if(positions.some(p=>Math.abs(p-position)<1))return false;positions.push(position);return true;});
      dots.replaceChildren();dots.hidden=positions.length<2;
      items.forEach((card,i)=>{const button=document.createElement('button');button.type='button';button.setAttribute('aria-controls',track.id);button.setAttribute('aria-label',window.EdenI18n.t("text_79e482be984e")+(i+1)+window.EdenI18n.t("text_3e3411e061cb")+items.length+': '+(card.dataset.roomName||card.querySelector('h3')?.textContent.trim()||''));button.addEventListener('click',()=>{go(i);schedule();});dots.append(button);});
      // Let the new hotel layout settle before restoring native scroll snapping.
      go(next,false);resetFrame=requestAnimationFrame(()=>{go(next,false);resetFrame=requestAnimationFrame(()=>{track.classList.remove('is-resetting');go(next,false);schedule();});});
    }
    on(track,'scroll',()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=0;mark(closest());});},{passive:true});
    on(dots,'keydown',event=>{
      let next;
      if(event.key==='ArrowRight')next=Math.min(index+1,positions.length-1);
      else if(event.key==='ArrowLeft')next=Math.max(index-1,0);
      else if(event.key==='Home')next=0;
      else if(event.key==='End')next=positions.length-1;
      else return;
      event.preventDefault();go(next);dots.children[next]?.focus({preventScroll:true});schedule();
    });
    on(track,'pointerdown',event=>{
      if(!event.isPrimary||event.button!==0||positions.length<2||event.target.closest('[data-room-card-gallery],button,input,select,textarea'))return;
      stop();gesture={id:event.pointerId,x:event.clientX,y:event.clientY,left:track.scrollLeft,index:closest(),time:performance.now(),active:false};
      // Stop any unfinished automatic movement before following the pointer.
      track.scrollTo({left:gesture.left,behavior:'instant'});
    });
    on(window,'pointermove',event=>{
      const g=gesture;if(!g||g.id!==event.pointerId)return;
      const dx=event.clientX-g.x,dy=event.clientY-g.y;
      if(!g.active){
        if(Math.max(Math.abs(dx),Math.abs(dy))<6)return;
        if(Math.abs(dy)>Math.abs(dx)){gesture=null;schedule();return;}
        g.active=true;track.classList.add('is-dragging');track.setPointerCapture(event.pointerId);
        const selection=window.getSelection();if(selection?.anchorNode&&track.contains(selection.anchorNode))selection.removeAllRanges();
      }
      if(event.cancelable)event.preventDefault();
      track.scrollLeft=g.left-dx;
    });
    function finish(event,cancelled=false){
      const g=gesture;if(!g||g.id!==event.pointerId)return;
      gesture=null;track.classList.remove('is-dragging');
      if(track.hasPointerCapture(event.pointerId))track.releasePointerCapture(event.pointerId);
      if(g.active){
        const dx=event.clientX-g.x,elapsed=Math.max(1,performance.now()-g.time),threshold=Math.min(44,Math.max(24,track.clientWidth*.08));
        const advance=!cancelled&&(Math.abs(dx)>=threshold||(Math.abs(dx)>=14&&Math.abs(dx)/elapsed>.4));
        ignoreClickUntil=performance.now()+250;go(g.index+(advance?(dx<0?1:-1):0));
      }
      schedule();
    }
    on(window,'pointerup',event=>finish(event));
    on(window,'pointercancel',event=>finish(event,true));
    on(track,'click',event=>{if(performance.now()<ignoreClickUntil){event.preventDefault();event.stopImmediatePropagation();}}, {capture:true});
    // The photo gallery keeps its own native scrolling and drag handling.
    on(track,'dragstart',event=>{if(!event.target.closest('[data-room-card-gallery]'))event.preventDefault();});
    on(scope,'pointerdown',stop,{passive:true});
    on(window,'pointerup',schedule,{passive:true});
    on(window,'pointercancel',schedule,{passive:true});
    on(root,'pointerenter',()=>{if(hover.matches)stop();});
    on(root,'pointerleave',schedule);
    on(scope,'focusin',schedule);
    on(scope,'focusout',()=>queueMicrotask(schedule));
    on(track,'wheel',schedule,{passive:true});
    on(document,'visibilitychange',schedule);
    on(window,'pagehide',stop);
    on(window,'pageshow',schedule);
    on(reduced,'change',schedule);
    if(tabs)[...tabs.querySelectorAll('button[data-stars]')].forEach((button,i)=>on(button,'click',()=>{
      tabs.dataset.tab=String(i+1);tabs.querySelectorAll('button[data-stars]').forEach(b=>b.setAttribute('aria-selected',String(b===button)));
      [...track.children].forEach(card=>{if(card.matches('.eg-card[data-stars]'))card.hidden=card.dataset.stars!==button.dataset.stars;});
      root.setAttribute('aria-label',window.EdenI18n.t("text_047320b9e7ed")+button.dataset.stars+' stele');refresh(0);
    }));
    let observedWidth=null;
    const resize=entries=>{
      const width=entries?.[0]?entries[0].contentRect.width:track.clientWidth;
      if(width===observedWidth)return;
      const measured=observedWidth!==null;observedWidth=width;
      if(measured&&!refreshFrame)refresh(index);
    };
    const sizeObserver=window.ResizeObserver?new ResizeObserver(resize):null;
    if(sizeObserver)sizeObserver.observe(track);else on(window,'resize',resize);
    const visibilityObserver=window.IntersectionObserver?new IntersectionObserver(entries=>{inView=entries[0].isIntersecting&&entries[0].intersectionRatio>=.25;schedule();},{threshold:[0,.25]}):null;
    if(visibilityObserver)visibilityObserver.observe(track);else inView=true;
    root.edenHomeRoomCarousel={go,refresh,destroy(){stop();cancelAnimationFrame(frame);cancelAnimationFrame(resetFrame);cancelAnimationFrame(refreshFrame);abort.abort();sizeObserver?.disconnect();visibilityObserver?.disconnect();root.classList.remove('is-carousel-ready');track.classList.remove('is-resetting','is-dragging');delete root.edenHomeRoomCarousel;}};
    refresh(0);
  }
  function mount(scope){scope.querySelectorAll('[data-home-room-carousel]').forEach(init);}
  window.EdenHomeRoomCarousel={mount};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-home-room-carousel]').forEach(root=>root.edenHomeRoomCarousel?.destroy()));
})();
